import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatePresence } from "framer-motion";
import '../style/Home.scss'
import "swiper/swiper.min.css";
import SubHeader from '../components/SubHeader';
import PriceBoxGas from '../components/profilo/PriceBox/PriceBoxGas'
import { useFetchLoginGas } from '../functions/loginGas';
import Header from '../components/Header';
import BoxPages from '../components/Home/BoxPages/BoxPages';
import NewHeader from '../components/New Header/NewHeader';
import SaldoGas from '../components/Saldo Gas/_saldo';
import LastFatturaGas from '../components/Last Fattura Gas/LastFatturaGas';
import CheckMethodPayment from '../components/ChekMethodPayment/CheckMethodPayment';
import AlertNotice from '../components/AlertNotice/AlertNotice';


function HomeGas() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const customerCode = useSelector((user) => user.gas?.info?.customer_code)
    const saldo = useSelector((user) => user.gas.saldo);
    const fetchLogin = useFetchLoginGas()
    const statusNotice = useSelector((user) => user?.gas?.popupInfo?.flag_popup);

    useEffect(() => {
        // fetchLogin()
    },[])
 
    return <div className='homeNew gas'>
        {statusNotice ? (
            <AlertNotice
            />
        ) : null}
        <div className="homeNew-top">
            <NewHeader logo='white' padding='no' iconsColor='white'/>
        </div>
        <div className="homeNew-bottom">
            <SubHeader />
            <AnimatePresence exitBeforeEnter>
                <SaldoGas />
                <BoxPages />
                <LastFatturaGas />
                <PriceBoxGas />
                <CheckMethodPayment />
            </AnimatePresence>
        </div>
    </div>;
}

export default HomeGas;
